<template>
    <div class="col-12">
        <div class=" row text-center ml-5">
            <h3 class="ui inverted purple text"><strong>Account Opening
                    Applications!</strong></h3>
            <p class="text-muted fw-light mt-4">If you need to update the documents on your application please click the
                Update Documents !</p>
        </div>

        <div class="row d-flex justify-content-center align-items-center mt-5">
            <div class="col-11 col-lg-9">

                <div class="row m-1">
                    <table class="ui celled purplescrolling long table">
                        <thead>
                            <tr>
                                <th>Account Type</th>
                                <th>Currency</th>
                                <th>Status</th>
                                <th>Rejection Reason</th>
                                <th class="right aligned">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="account in accounts" :key="account.id">
                                <td>{{ account.accountType }}</td>
                                <td>{{ account.currency }}</td>
                                <td v-if="account.status === 'PENDING_MANUAL'">PENDING AUTHORIZATION</td>
                                <td v-if="account.status === 'PENDING_REJECTED'">REJECTED</td>
                                <td v-if="account.status === 'PENDING_UPGRADE'">PENDING AUTHORIZATION</td>
                                <td v-if="account.status === 'UNDER_REVIEW'">UNDER REVIEW</td>
                                <td>{{ account.rejectionReason }}</td>
                                <td v-if="account.status === 'PENDING_REJECTED'" class="right aligned">
                                    <div class="ui small primary labeled icon button"
                                        @click="updateDocuments(account.uid)">
                                        <i class="book icon"></i> Update Documents
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>

                <div class="mt-4">
                    <button @click="back()" class="ui grey button fluid">Back</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";
//import { http } from "@/utils/http";


export default {
    name: "ViewAccountApplications",
    data() {
        return {
            accounts: [],
        };
    },
    mounted() {
        this.getAccountsApplications();
    },
    methods: {
        updateDocuments(uid) 
        {
        localStorage.setItem('account-uid', uid);
        this.$router.push('/account-opening/update-t24-documents')
        },
        getAccountsApplications() {
            this.get(URLS.accounts + '/account-applications', false)
                .then(res => {
                    this.accounts = res.body;
                    console.log(this.accounts);
                    if (!res) return;
                    if (res.errors) return this.errors = res.errors;

                })
        },
        back() {
            this.$router.push("/account-opening/home");
        },
        submitForm() { },
        ...baseMethods,
    }
};
</script>